import React from 'react';
import Link from 'gatsby-link';
import arrow from './arrow.png';
import home from './homeimg.png';

let renderedItems = [];

const Menu = ( { nodes, pages, withChildren = false, pathContext = false, mobile = false} ) => {
  renderedItems = [];
  if (!nodes.length) return null;

  const pageId = pathContext.index;
  const parent = nodes[0] ? findParent(nodes[0].node.context.parent, pages) : null;

  if (mobile) return (
    <ul>
      <li className="link link-home"><img className="home-img" src={home} width="44px" height="27px" alt=""/> <Link to={'/'}>Accueil</Link></li>
      { nodes.map( ({ node }) => renderLevel(node, pages, withChildren, pageId, mobile))}
    </ul>
  );

  return (
    <ul id={nodes[0] ? nodes[0].node.context.parent : 'none' } >
      { withChildren && parent ? 
        <span>
          <li className="no-border home-img-container"><img className="home-img" src={home} width="44px" height="27px" alt=""/> {parent.context.title}</li>
          {/* parent ? <li className="no-border"><Link className="btn btn-primary btn-sm home-btn" to={parent.path}>{parent.context.title}</Link></li> : null */}    
        </span>
      : 
        null
      }
        { nodes.map( ({ node }) => renderLevel(node, pages, withChildren, pageId))}
    </ul>
  )
}

const findParent = (index, pages) => {
  const parent = pages.edges.find(page => page.node.context.index === index);
  return parent ? parent.node : null;
} 

const renderLevel = (node, pages, withChildren, pageId, mobile) => {
  if (renderedItems.includes(node.id)) return null;
  renderedItems.push(node.id);

  let classes = '';
  if (pageId && !withChildren) {
    const ids = pageId.split('-');
    if (ids[0] === node.context.index) classes='active';
  } else if (pageId) {
     if (pageId === node.context.index) classes='active';
  }

  if (node.context.hasChildren && withChildren) {
    const children = pages.edges.filter((child) => {
      const regex = new RegExp('^' + node.context.index + '-');
      return child.node.context.index.match(regex);
    });
    return (
      <li key={node.id} className={classes} data-index={node.context.index}>
        <div className="link">
          <Link to={node.path}>
            {node.context.title}
          </Link>
        </div>
        { node.context.hasChildren ? (
          <a href="#" className="arrow">
            <span>&rsaquo;</span>
          </a>
        ) : '' }
        <ul data-parent={node.context.index}>
          <li className={`${ mobile ? '' : 'no-border '}back-container`}><img src={arrow} /><a href="#" className="back">Retour: {node.context.title}</a></li>
          {children.map(child => renderLevel(child.node, pages, true, pageId))}
        </ul>
      </li>
    );
  } else {
    return (
      <li key={node.id} className={classes} data-index={node.context.index} data-path={node.path}>
        <Link to={node.path}>
          {node.context.title}
        </Link>
      </li>
    );
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/index.js